<ic-auth-wrapper>
	<pv-login-form [loading]="loading" [organisation]="organisation$ | async" (authenticate)="onAuthenticate($event)">
		@if (error$ | async) {
			<p class="message error" data-test="error-message">
				<i class="fa fa-exclamation-triangle"></i> {{ error$ | async | translate }}
			</p>
		}
		@if (inactivity()) {
			<p class="message inactive">{{ "auth.errors.timed_out" | translate }}</p>
		}
	</pv-login-form>
	<div class="ic-btn ic-center select-organisation">
		<a data-test="change-organisation-button" (click)="selectOrganisation()">{{
			"general.change_organisation" | translate
		}}</a>
	</div>
</ic-auth-wrapper>
